import { FunctionComponent, useEffect, useRef, useState } from 'react';
import { ContainerProps } from './types';
import View from './view';

/**
 * An icon floating around that is randomly displayed in
 * different sizes and automatically fades in and out.
 */
const Container: FunctionComponent<ContainerProps> = (props) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState<boolean>(false);

  // Update visible state when element enter or exit view
  useEffect(() => {
    const handleVisible = () => {
      const element = elementRef.current;
      if (element) {
        const rect = element.getBoundingClientRect();
        setVisible(
          rect.top + rect.height * 2 > 0 &&
            rect.left + rect.width * 2 > 0 &&
            rect.bottom - rect.height * 2 < window.innerHeight &&
            rect.right - rect.width * 2 < window.innerWidth
        );
      }
    };
    handleVisible();
    window.addEventListener('scroll', handleVisible);
    return () => {
      window.removeEventListener('scroll', handleVisible);
    };
  }, []);

  return <View {...props} elementRef={elementRef} visible={visible} />;
};

export default Container;
